import angular from 'angular';
import '../core/data-access/announcement.data-access.js';

(function() {
    'use strict';
    angular.module('app.announcement').factory('AnnouncementSvc', AnnouncementSvc);

    AnnouncementSvc.$inject = ['AnnouncementDA','ANNOUNCEMENT'];

    /* @ngInject */
    function AnnouncementSvc(AnnouncementDA,ANNOUNCEMENT) {
        var exports = {
            getLangs:getLangs,
            getCategories:getCategories,
            createAnnouncement: createAnnouncement,
            getAllAnnouncements:getAllAnnouncements,
            getAnnouncement:getAnnouncement,
            deleteAnnouncement:deleteAnnouncement,
            updateAnnouncement:updateAnnouncement,
        };

        return exports;

        /**
         * Récupération des langues disponibles
         */
        function getLangs() {
            return angular.copy(ANNOUNCEMENT.langs);
        }
        /**
         * Récupération des categories disponibles
         */
        function getCategories() {
            return angular.copy(ANNOUNCEMENT.allCategories);
        }

        function createAnnouncement(announcement) {
             return AnnouncementDA.createAnnouncement(announcement);
        }

        function updateAnnouncement(announcement) {
             return AnnouncementDA.updateAnnouncement(announcement);
        }

        function  getAllAnnouncements(page = 0, size = 20) {
             return AnnouncementDA.getAllAnnouncements(page , size ) ;
        }

        function  getAnnouncement(id) {
             return AnnouncementDA.getAnnouncement(id ) ;
        }

        function  deleteAnnouncement(id) {
             return AnnouncementDA.deleteAnnouncement(id ) ;
        }
    }
})();
